export const getLocation = (href) => {
  var l = document.createElement("a");
  l.href = href;
  return l.pathname + l.search;
};
